angular.module('services.endpoints.MethodsService', [
  'global'
])

/**
 * The MethodsService service stores methods used to access
 * system APIs.
 *
 * @class MethodsService
 * @constructor
 * @module services.endpoints.MethodsService
 */
.factory('MethodsService', [
  'ModelsService',
  'EndpointsService',
  function (ModelsService, EndpointsService) {
    'use strict';

    var service = {
      methodsEdit: null,

      /**
       * Returns the content creation object
       *
       * @return {Object} Content creation object
       */
      getMethodsEdit: function getMethodsEdit() {
        if (EndpointsService.current.instance) {
          service.methodsEdit = service.setMethodsEdit();
        }
        return service.methodsEdit;
      },

      /**
       * Sets the methodsEdit Object based on the
       * current endpoint
       *
       * @return {Object} method object
       */
      setMethodsEdit: function setMethodsEdit() {
        var schema = ModelsService.find('schemas', 'label', 'method');
        var methodsEdit = {};

        methodsEdit.schema = schema.content.schema;
        methodsEdit.form = schema.content.form;
        methodsEdit.model = { methods: _.clone(EndpointsService.current.instance.methods) };

        console.log('setMethodsEdit: methodsEdit', methodsEdit);
        return methodsEdit;
      },

      /**
       * Formats and saves method edit data on an instance
       *
       * @param {Object} method - Method data to update on endpoint
       * @param {string} schema - Schema used to validate the content
       * @param {Object} instance - Instance to update
       * @return {Promise<Object>} updated methods
       */
      saveMethodsEditData: function saveMethodsEditData(method, schema, instance) {
        var data = {};

        data.methods = method.methods;
        data.schema = schema;

        console.log('MethodsService: saveContentCreateData: data', data);
        return ModelsService.update(instance, data);
      }

    };

    return service;
  }
]);
